import React, { Component } from "react";
import {
  Route,
  NavLink,
  HashRouter
} from "react-router-dom";
import Home from "./Home";
import Registration from "./Registration";
import Conditions from "./Conditions";


class Main extends Component {
  render() {
    return (
      <HashRouter>
        <div>
          <h1>Pálfy garden</h1>
          <blockquote><i>"Chutné ovocie z brehu Malého Dunaja."</i></blockquote>
          <ul className="header">
            <li><NavLink exact to="/">Ovocie</NavLink></li>
            <li><NavLink to="/registration">Zapísanie</NavLink></li>
            <li><NavLink to="/conditions">Podmienky</NavLink></li>
          </ul>
          <div className="content">
            <Route exact path="/" component={Home}/>
            <Route path="/registration" component={Registration}/>
            <Route path="/conditions" component={Conditions}/>
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js